export const SET_MY_STATES = 'SET_MY_STATES';
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS';
export const SET_RESTAURANTS = 'SET_RESTAURANTS';
export const SET_MENU_ITEM_DIALOG_DATA = 'SET_MENU_ITEM_DIALOG_DATA';
export const SET_MENU_ITEM_DIALOG_OPEN = 'SET_MENU_ITEM_DIALOG_OPEN';
export const SET_DIALOG = 'SET_ALERT_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_ALERT_DIALOG';
export const SET_EDIT_RESTAURANTS = 'CLOSE_ALERT_DIALOG';
export const SET_EDIT_RESTAURANTS_OPEN = 'SET_EDIT_RESTAURANTS_OPEN';
export const SET_SIGN_IN_REG_DIALOG_TYPE = 'SET_SIGN_IN_REG_DIALOG_TYPE';
export const SET_SIGN_IN_REG_DIALOG_TITLE = 'SET_SIGN_IN_REG_DIALOG_TITLE';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_ID_TOKEN = 'SET_ID_TOKEN';
export const SET_CUSTOM_ID = 'SET_CUSTOM_ID';
export const SET_LOGIN_TYPE = 'SET_LOGIN_TYPE';
export const SET_ASSOCIATE_RESTAURANTS = 'SET_ASSOCIATE_RESTAURANTS';
export const SET_ASSOCIATE = 'SET_ASSOCIATE';
export const SET_ASSOCIATE_DIALOG_DATA = 'SET_ASSOCIATE_DIALOG_DATA';
export const SET_ASSOCIATE_DIALOG_OPEN = 'SET_ASSOCIATE_DIALOG_OPEN';
export const SET_RESTAURANT_MENU_ITEMS = 'SET_RESTAURANT_MENU_ITEMS';
export const SET_RESTAURANT_ID = 'SET_RESTAURANT_ID';
export const SET_RESTAURANT_MENU_DAY_ITEMS = 'SET_RESTAURANT_MENU_DAY_ITEMS';
export const SET_MENU_DAY_DIALOG_DATA = 'SET_MENU_DAY_DIALOG_DATA';
export const SET_MENU_DAY_DIALOG_OPEN = 'SET_MENU_DAY_DIALOG_OPEN';
export const SET_RESTAURANT_ASSOCIATES = 'SET_RESTAURANT_ASSOCIATES';
export const SET_LOADING = 'SET_LOADING';
export const SET_RESTAURANT = 'SET_RESTAURANT';
export const SET_ASSOCIATES = 'SET_ASSOCIATES';
export const SET_MENU_DAYS = 'SET_MENU_DAYS';
export const SET_LOADING_DIALOG = 'SET_LOADING_DIALOG';
export const SET_ENTERTAINMENT_ITEMS = 'SET_ENTERTAINMENT_ITEMS';
export const SET_ENTERTAINMENT_ITEM_DIALOG_DATA = 'SET_ENTERTAINMENT_ITEM_DIALOG_DATA';
export const SET_ENTERTAINMENT_ITEM_DIALOG_OPEN = 'SET_ENTERTAINMENT_ITEM_DIALOG_OPEN';
export const SET_RESTAURANT_ENTERTAINMENT_ITEMS = 'SET_RESTAURANT_ENTERTAINMENT_ITEMS';
export const SET_ON_SCREEN_DEBUG_MESSAGE = 'SET_ON_SCREEN_DEBUG_MESSAGE';
export const SET_PHOTOS = 'SET_PHOTOS';
export const SET_RESTAURANT_PHOTOS = 'SET_RESTAURANT_PHOTOS';
export const SET_PHOTO_DIALOG_DATA = 'SET_PHOTO_DIALOG_DATA';
export const SET_PHOTO_DIALOG_OPEN = 'SET_PHOTO_DIALOG_OPEN';
export const SET_IMAGE_EDITOR_DATA = 'SET_IMAGE_EDITOR_DATA';
export const SET_TODAYS_DATE = 'SET_TODAYS_DATE';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';